import React from "react";
import "./detail-card.scss";

export interface DetailCardProps
  extends React.HTMLAttributes<HTMLDivElement> {
  title: string;
  badge?: React.ReactNode;
  actions?: React.ReactNode;
  headerClassName?: string;
  bodyClassName?: string;
  borderColor?: string;
}

const DetailCard = ({
  title,
  badge,
  actions,
  headerClassName,
  bodyClassName,
  borderColor,
  children,
  className,
  style,
  id,
  ...rest
}: DetailCardProps) => {
  const cls = "detail-card";

  const rootClass = [cls, className].filter(Boolean).join(" ");

  const rootStyle: React.CSSProperties = {
    ...(borderColor ? { borderColor } : {}),
    ...style,
  };

  const hasStyle = Object.keys(rootStyle).length > 0;

  const titleId = id ? `${id}-title` : undefined;

  return (
    <section
      id={id}
      className={rootClass}
      style={hasStyle ? rootStyle : undefined}
      aria-labelledby={titleId}
      {...rest}
    >
      <div
        className={[`${cls}__header`, headerClassName]
          .filter(Boolean)
          .join(" ")}
      >
        <div className={`${cls}__header-left`}>
          <h3 id={titleId} className={`${cls}__title`}>
            {title}
          </h3>
          {badge != null && (
            <span className={`${cls}__badge`}>{badge}</span>
          )}
        </div>
        {actions != null && (
          <div className={`${cls}__actions`}>{actions}</div>
        )}
      </div>
      {children != null && (
        <div
          className={[`${cls}__body`, bodyClassName]
            .filter(Boolean)
            .join(" ")}
        >
          {children}
        </div>
      )}
    </section>
  );
};

export { DetailCard };
export default DetailCard;
